export const showCollectionSellingInfo = (
  isSelling: boolean,
  pricing: number,
  currency: string,
  isStudent: boolean,
  need_registration: boolean
) =>
  isSelling &&
  pricing !== null &&
  pricing !== 0 &&
  currency !== null &&
  !isStudent &&
  !need_registration
